import { Component, computed, input } from '@angular/core';
import { Wrap } from './Wrap';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

@Component({
  selector: 'Breadcrumbs',
  imports: [Wrap],
  template: `
    <section class="hidden md:block">
      <Wrap
          [class]="
          'border-b border-gray-300 text-gray-400 py-6 leading-tight flex flex-wrap gap-2'
        "
      >
        @for (item of allItems(); track $index) {

          @if (item.href) {
            <a
                [href]="item.href"
                class="font-bold flex flex-nowrap items-center hover:text-blue-500"
            >
              {{ item.label }}

              <svg
                  class="shrink-0 ml-2"
                  fill="none"
                  height="16"
                  stroke-width="3"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </a>
          }

          @if (!item.href) {
            <span>{{ item.label }}</span>
          }

        }
      </Wrap>
    </section>
  `,
})
export class Breadcrumbs {
  items = input<BreadcrumbItem[]>([]);

  // Always start with a link to the homepage (without mutating the input array)
  allItems = computed<BreadcrumbItem[]>(() => [
    { label: 'Combidesk', href: '/' },
    ...this.items(),
  ]);
}
